import Transforms from './transforms'

const endpoints = {
    signin: {
        method: 'POST',
        path: '/auth/signin',
        transform: Transforms.signin,
    },
}

export default {
    name: 'auth',
    endpoints,
}
